import React, { useCallback, useRef } from 'react';
import { useIntl } from 'react-intl';

import { BottomControls } from '../bottom-controls/bottom-controls';
import { OnboardingTitleDesc } from '../onboarding-title-desc/onboarding-title-desc';
import { OrientationType } from '../../../types';
import { ReportCard } from '../../report-card/report-card';
import { useOnboardingContext } from '../../../onboarding.context';
import { useReportTemplates } from '../../../use-report-templates';

import styles from './onboarding-template-screen.scss';

export const OnboardingTemplateScreen = () => {
  const intl = useIntl();
  const { createNewReport } = useReportTemplates();
  const { handleEnd, handleNext } = useOnboardingContext();
  const busy = useRef(false);

  const onCreateNewReport = useCallback(
    async (orientation: OrientationType) => {
      if (!busy.current) {
        busy.current = true;
        const report = await createNewReport(orientation, undefined, true);

        if (report) {
          handleNext(report);
        } else {
          busy.current = false;
        }
      }
    },
    [createNewReport, handleNext]
  );

  return (
    <>
      <OnboardingTitleDesc
        title={intl.formatMessage({
          id: 'onboarding.what_type_of_report_do_you_want',
          defaultMessage: 'What type of report do you want?'
        })}
        desc={intl.formatMessage({
          id: 'onboarding.you_can_always_change_this_later',
          defaultMessage: 'You can always change this later in report settings.'
        })}
        style={{ margin: '120px auto 80px', textAlign: 'center' }}
      />

      <div className={styles.cardContainer}>
        <ReportCard
          title={intl.formatMessage({ id: 'reporting.landscape_report', defaultMessage: 'Landscape report' })}
          hasAddIcon
          orientation="landscape"
          onClick={() => onCreateNewReport('landscape')}
          large
        />
        <ReportCard
          title={intl.formatMessage({ id: 'reporting.portrait_report', defaultMessage: 'Portrait report' })}
          hasAddIcon
          orientation="portrait"
          onClick={() => onCreateNewReport('portrait')}
          large
        />
        <ReportCard
          title={intl.formatMessage({ id: 'reporting.dashboard', defaultMessage: 'Dashboard' })}
          hasAddIcon
          orientation="dashboard"
          onClick={() => onCreateNewReport('dashboard')}
          large
        />
      </div>

      <BottomControls addSpacer onEnd={handleEnd} />
    </>
  );
};
